import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

export const ProfileSettings = ({ session, onClose, inline = false }) => {
  const { t } = useTranslation();
  return (
    <div className={inline ? "w-full" : "fixed inset-0 z-[150] bg-black/50 backdrop-blur-sm flex items-center justify-center p-6"}>
      <div className="w-full max-w-md bg-white border border-gray-200 p-10 rounded-[3rem] shadow-2xl text-gray-900 relative">
        <button onClick={onClose} className="absolute top-8 right-8 text-gray-400 hover:text-gray-900 transition-colors"><X size={24} /></button>

        <h2 className="text-2xl font-black uppercase italic tracking-tight mb-8">{t('ProfileSettings.settings_profilya')}</h2>

        <div className="p-4 bg-white rounded-2xl mb-6 border border-gray-200">
          <p className="text-[10px] text-gray-400 uppercase tracking-widest mb-1">{t('ProfileSettings.user')}</p>
          <p className="font-bold text-gray-900">{session.client_id}</p>
          <p className="text-xs text-gray-500">{session.role}</p>
        </div>
      </div>
    </div>
  );
};
